import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

const field = "h-12 rounded-xl border-[#D4AF37]/25 bg-[#190317]/60 text-[#FFF8EF] focus-visible:ring-[#D4AF37]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grain relative flex min-h-screen items-center justify-center overflow-hidden bg-[#240620] px-5" data-testid="admin-login-page">
      <div className="pointer-events-none absolute -left-20 top-10 h-96 w-96 rounded-full bg-[#E91E63]/20 blur-[120px]" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-[28px] border border-[#D4AF37]/25 bg-[#330B2E]/80 p-8 backdrop-blur-xl" data-testid="admin-login-form">
        <Link to="/" className="inline-block rounded-xl bg-[#FFF8EF] px-2 py-1"><img src="/brand/logo-tight.webp?v=3" alt="SkandaSri Eventz" className="h-12 w-auto" /></Link>
        <h1 className="mt-6 flex items-center gap-2 font-display text-4xl text-[#FFF8EF]"><Lock size={22} className="text-[#D4AF37]" /> Admin</h1>
        <p className="mt-1 text-sm text-[#E8D8C8]">Manage gallery photos and customer enquiries.</p>
        <div className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="adm-email" className="text-[#F3E5AB]">Email</Label>
            <Input id="adm-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="admin-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="adm-pass" className="text-[#F3E5AB]">Password</Label>
            <Input id="adm-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="admin-password-input" />
          </div>
          {error && <p className="text-sm text-[#ff8fb3]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-gold-foil py-4 text-sm font-semibold text-[#240620] disabled:opacity-60" data-testid="admin-login-submit">
            {busy && <Loader2 size={16} className="animate-spin" />} Sign in
          </button>
        </div>
      </form>
    </main>
  );
}
